import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';

export function useWorkflowTemplate(id?: string | null): {
  workflowTemplate?: MBAPI.WorkflowTemplate;
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    MBAPI.GetWorkflowTemplateQuery,
    MBAPI.GetWorkflowTemplateQueryVariables
  >(Queries.workflow.getWorkflowTemplate, {
    variables: { id: id ?? '' },
    skip: isNil(id),
  });
  const workflowTemplate = data?.getWorkflowTemplate ?? undefined;
  return { workflowTemplate, loading, error };
}
